import { ButtonTheme } from "../../hooks/useButtonTheme";
import Image from "../Image";
import LinkButton from "../LinkButton";
import React from "react";

export interface BannerProps {
  header: string;
  title: string;
  button: {
    to: string;
    text: string;
    theme?: ButtonTheme;
  };
  bgImage: string;
}

const Banner = ({ header, title, button, bgImage }: BannerProps) => {
  return (
    <Image src={bgImage}>
      <div className="flex items-center justify-center h-full">
        <div className="max-w-xl p-4 py-12 space-y-2 text-center">
          <div className="text-base">{header}</div>
          <div className="text-4xl font-bold leading-tight md:text-5xl">
            {title}
          </div>
          <LinkButton to={button.to} theme={button.theme}>
            {button.text}
          </LinkButton>
        </div>
      </div>
    </Image>
  );
};

export default Banner;
